import Vue from 'vue';
import VatChecker from '../api/Vat';

export default class VatValidator {

    constructor(vatid, country, vatCountries) {
        this.errors = {};
        this.vatid = vatid;
        this.country = country;
        this.vatCountries = vatCountries;
    }

    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validateVat () {
        this.flushError('vatid');
       //  console.log('Countries which need VAT:',this.vatCountries);
        const needsVat = this.vatCountries.some(vatCountry => vatCountry.id === this.country);

        console.log('Validating Vat-Id:',this.vatid, ' country:',this.country, ' needsVatId:',needsVat);
        if (!needsVat){return;}
        if(!this.vatid) {
            Vue.set(this.errors, 'vatid', 'page_setcontact.error.vatidmissing');
        } else {
            VatChecker.check(this.vatid, this.country).then(({data}) => {
                if(!data.success){
                    Vue.set(this.errors, 'vatid', 'page_setcontact.error.vatidunchecked');
                }
            }).catch(() => {
                Vue.set(this.errors, 'vatid', 'page_setcontact.error.vatidunchecked');
            })
        }
    }

    validateVatForm (vatCountries) {
        // console.log('validateVatForm vatCountries:', vatCountries);
        this.flushError('vatid');
        const vatCountry = vatCountries.find(obj => obj.id === this.country);
        if(!this.vatid) {
            Vue.set(this.errors, 'vatid', 'page_setcontact.error.vatidmissing');
        } else {

            if(vatCountry){
            const regex = new RegExp("^"+vatCountry.regex+"$");
            if(!regex.test(this.vatid)) {
                Vue.set(this.errors, 'vatid', 'page_setcontact.error.vatidunchecked');
            }
            }

            
        }
    }

    validateAll() {
        this.validateVat();
    }
}